import Api from '@/services/Api'
import axios from 'axios'
import isEmpty from '@/outils/isEmpty'
export default {
  login (email, pass) {
    return new Promise((resolve, reject) => {
      Api()
        .post('/Home/Login', {email: email, password: pass},{headers: {
          "Access-Control-Allow-Origin": "*",}})
        .then(res => {
          if (res.status == 200 && !isEmpty(res.data) && isEmpty(res.data.err))
          { 
            console.log(res)
            localStorage.setItem('authToken', res.data.token)
            resolve(res)
          }
          else
            reject('Error Try Again')
        })
        .catch(err => reject(err))
    })
  },
  AddAdmin (email, pass , name) {
    return new Promise((resolve, reject) => {
      Api()
        .post('/Home/Creat', {email: email, password: pass ,name_company :name})
        .then((r) => {
          resolve(r)
        })
        .catch(err => {
          console.log(err)
          reject(err)}
        )
    })
  },
  checktoken(token){
    return new Promise((resolve, reject) => {
      Api()
        .post('/Home/token', {token: token})
        .then(res => {
          if(res.status == 403) {
            localStorage.removeItem("authToken");
            reject('res')
          }else
            resolve(res)
        })
        .catch((err) => {
          localStorage.removeItem("authToken");
          reject(err)
        })
  })
 },
 GetUser(token){
  return new Promise((resolve, reject) => {
    Api()
      .post('/Home/User', {token: token})
      .then(res => {
        resolve(res)
      })
      .catch((er) => reject(er))
  })
  },
  Updatedetails(data, old){
    return new Promise((resolve, reject) => {
      Api()
        .post('/Home/Update', {data: data, d: old})
        .then(res => {
          if (res.data.err)
            reject(res.data.err)
          resolve(res)
        })
        .catch((er) => reject(er))
   })
  },
  getNotifs(){
    return new Promise((resolve, reject) => {
      Api()
        .get('/Home/getNotifs')
        .then(res => {
          resolve(res)
        })
        .catch((er) => reject(er))
   })
  },
}